/**
 * @file synopsis
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'


class Synopsis extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() { }

    render() {
        let introlist = [
            {
                title: '学员分布',
                mediaUrl: '//cdn.ihatoo.com/hatu-official/join/f3-icon-xyfb.png'

            },
            {
                title: '师资力量',
                mediaUrl: '//cdn.ihatoo.com/hatu-official/join/f3-icon-dlgj.png'

            },
            {
                title: 'CCTV专题报道',
                mediaUrl: '//cdn.ihatoo.com/hatu-official/join/f3-icon-cctv.png'

            },
            {
                title: '专注在线中文教育8年',
                mediaUrl: '//cdn.ihatoo.com/hatu-official/join/f3-icon-lhg.png'

            },

        ]
        return (
            <div id="synopsis">
                <div className="make-title">哈兔简介</div>
                <div className="heng"></div>
                <ul className="intro">
                    {introlist.map((item, index) => (
                        <li key={'intro-' + index}>
                            <div className="img" style={{ backgroundImage: `url(${item.mediaUrl})` }}></div>
                            <div className="title">{item.title}</div>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}

export default Synopsis
